// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cognito-watcher-title {
  color: red;
  font-weight: 600;
  font-family: 'Poppins';
  font-size: 12px;
  padding-left: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/presentation/styles/global-plain.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".cognito-watcher-title {\n  color: red;\n  font-weight: 600;\n  font-family: 'Poppins';\n  font-size: 12px;\n  padding-left: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
